import {controller, target} from '@github/catalyst'

@controller
export class StoryBodyElement extends HTMLElement {
  @target declare body: HTMLLinkElement

  connectedCallback() {
    window.onload = () => this.addTwitterLink()
  }

  // TestimonialComponent is run through the rich text parser and doesn't have context of request
  // so we need to add the twitter link in js
  addTwitterLink() {
    // data-target is stripped in the HTML sanitizer (else we'd use data attributes)
    const testimonials: NodeListOf<HTMLDivElement> = this.body.querySelectorAll('.js-story-testimonial')
    for (const testimonial of testimonials) {
      const quote = testimonial.querySelector('.js-story-testimonial-quote')?.textContent as string
      const link = testimonial.querySelector('.js-testimoniial-tweet') as HTMLLinkElement
      link.href = `https://twitter.com/intent/tweet?url=${encodeURI(window.location.href)}&text=${encodeURI(
        quote.trim(),
      )}`
      link.removeAttribute('hidden')
    }
  }
}
